import { styled, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { colorLabel } from 'shared/Providers/MuiTheme'

export const Page = styled('div', { name: 'Page' })(({ theme }) => ({
	height: '100%',
	overflow: 'auto',
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	paddingTop: theme.spacing(4),
}))

export const PageListHeaderContainer = styled('div', { name: 'PageListHeaderContainer' })(({ theme }) => ({
	display: 'flex',
	gap: theme.spacing(2),
	flexWrap: 'wrap',
	paddingBottom: theme.spacing(2),
	// boxShadow: theme.shadows[1],
	[theme.breakpoints.up('md')]: {
		position: 'relative',
		flexWrap: 'unset',
	},
}));

export const PageHeaderContainer = styled('div', { name: 'PageHeaderContainer' })(({ theme }) => ({
	display: 'flex',
	gap: theme.spacing(2),
	// flexWrap: 'unset',
	paddingBottom: theme.spacing(2),
}));

export const PageListHeaderTitleContainer = styled('div', { name: 'PageListHeaderTitleContainer' })(
	({ theme }) => ({
		display: 'flex',
		gap: theme.spacing(2),
		alignItems: 'baseline',
		justifyContent: 'center',
		flex: 1,
		minWidth: '0',
		paddingRight: theme.spacing(4),
	}),
);

export const PageHeaderTitleContainer = styled('div', { name: 'PageHeaderTitleContainer' })(
	({ theme }) => ({
		...theme.typography.h1,
		color: colorLabel,
		paddingRight: theme.spacing(4),
		flex: 1,
	}),
);

export const PageListTitle = styled(Typography, { name: 'PageListTitle' })(({ theme }) => ({
	fontSize: '2rem',
	[theme.breakpoints.up('sm')]: {
		fontSize: '2.25rem',
	},
	[theme.breakpoints.up('md')]: {
		fontSize: '2.5rem',
	},
}));
PageListTitle.defaultProps = { ...PageListTitle.defaultProps, variant: 'h1', noWrap: true };

export const PageTitle = styled(Typography, { name: 'PageTitle' })(({ theme }) => ({
	color: theme.palette.primary.main,
	display: 'inline',
}));
PageTitle.defaultProps = { ...PageTitle.defaultProps, variant: 'h1' };

export const PageHeaderCount = styled('span', { name: 'PageHeaderCount' })(({ theme }) => ({
	...theme.typography.h1,
	flexShrink: 0,
	color: theme.palette.secondary.main,
	fontSize: '1.125rem',
	[theme.breakpoints.up('md')]: {
		fontSize: '1.125rem',
	},
}));

export const PageListHeaderActions = styled('div', { name: 'PageListHeaderActions' })(({ theme }) => ({
	display: 'flex',
	columnGap: theme.spacing(2),
	alignSelf: 'center',
	alignItems: 'center',
	minWidth: '100%',
	justifyContent: 'space-between',
	[theme.breakpoints.up('md')]: {
		position: 'absolute',
		right: 0,
		top: '50%',
		transform: 'translateY(-50%)',
	},
}));

export const PageHeaderActions = styled('div', { name: 'PageHeaderActions' })(({ theme }) => ({
	display: 'flex',
	columnGap: theme.spacing(2),
	alignSelf: 'baseline',
	alignItems: 'center',
	justifyContent: 'space-between',
}));

export const PageHeaderActionsLeft = styled('div', { name: 'PageHeaderActionsLeft' })(({ theme }) => ({
	display: 'flex',
	columnGap: theme.spacing(2),
	alignSelf: 'center',
	alignItems: 'center',
}));
export const PageHeaderActionsRight = styled('div', { name: 'PageHeaderActionsRight' })(({ theme }) => ({
	display: 'flex',
	columnGap: theme.spacing(2),
	alignSelf: 'center',
	alignItems: 'center',
	marginRight: theme.spacing(4),
}));

const PageContent = styled('div', { name: 'PageContent' })({
	height: '100%',
	overflow: 'auto',
	flex: 1,
});

export const PageFilters = styled('div', { name: 'PageFilters' })(({ theme }) => ({
	display: 'flex',
	padding: theme.spacing(4),
	paddingLeft: theme.spacing(2),
	gap: theme.spacing(2),
	alignItems: 'center',
}));

export const PageContentList = styled(PageContent, { name: 'PageContentList' })({
	display: 'flex',
	flexDirection: 'column',
});

export const PageItem = styled('div', { name: 'PageItem' })(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: theme.spacing(4),
	borderBottom: `1px solid ${grey[300]}`,
	'&:hover': {
		backgroundColor: 'rgba(0, 0, 0, 0.05)',
	},
}));

export const PageHeaderBreadcrumb = styled(Typography, { name: 'PageHeaderBreadcrumb' })(({ theme }) => ({
	color: theme.palette.secondary.main,
}));
PageHeaderBreadcrumb.defaultProps = { ...PageHeaderBreadcrumb.defaultProps, variant: 'h1', noWrap: true };
